import { set_ui_settings } from '../redux/settings-actions';
export function changeUserTheme(themeType) {
    return set_ui_settings({ themeType });
}
